var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "figure",
    { staticClass: "c-missing-image" },
    [
      _c("MissingImageIcon"),
      _vm._v(" "),
      _c("figcaption", [_vm._t("default")], 2)
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }